import React from 'react'
import Field from '../../common/FormField'

export default ({ data, onChangeFactory, disabled }) =>
  <fieldset>
    <Field type="textarea textarea-expandable" name="Public Item Description">
      <textarea
        rows="5"
        className="custom-scroll"
        placeholder="Enter basic details about the item (i.e. style, brand, etc.)"
        value={data.ringDescription}
        onChange={onChangeFactory('ringDescription')}
        disabled={disabled}
      />
      <div className="note">Visible to the public.</div>
    </Field>
    <Field type="textarea textarea-expandable" name="Internal-Use Item Notes">
      <textarea
        rows="5"
        className="custom-scroll"
        placeholder="Enter any extra details about the item (i.e. black inclusions on table)"
        value={data.extraDescription}
        onChange={onChangeFactory('extraDescription')}
        disabled={disabled}
      />
      <div className="note">Not visible to the public. Internal use only.</div>
    </Field>
  </fieldset>
